// extracted by mini-css-extract-plugin
export default {"container":"newCard_container__t2rk2","cardImage":"newCard_cardImage__uzoup","price":"newCard_price__j4CiP","content":"newCard_content__AjpTv","btn":"newCard_btn__mcqPo"};